import styled from 'styled-components'
import { Info } from 'react-feather'
import { Tooltip } from '@mui/material'

export const InfoButton = styled(Info)`
    cursor: pointer;
    color: blue;
`

export const CellTolltip = styled(Tooltip)`
  cursor: pointer;
`

export const ProductInfoContainer = styled.div`
  margin-bottom: 20px;
  padding: 16px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
`

export const ProductInfoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 16px;
  margin-bottom: 12px;
`

export const ProductInfoRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  gap: 16px;
`

export const ProductInfoLabel = styled.div`
  font-weight: bold;
  font-size: 14px;
  color: #495057;
`

export const ProductInfoValue = styled.div`
  font-size: 14px;
  color: #212529;
`

export const TableWrapper = styled.div`
  margin-bottom: 20px;
  margin: 20px;
  font-size: 11px;
`

export const CompactTableStyle = styled.div`
  & .MuiTableCell-root {
    padding: 4px 6px !important;
    font-size: 11px !important;
    line-height: 1.2 !important;
  }
  & .MuiTableHead-root .MuiTableCell-root {
    font-weight: bold !important;
    font-size: 10px !important;
    padding: 6px 6px !important;
  }
  & .MuiTableBody-root .MuiTableRow-root {
    height: 28px !important;
  }
  & .MuiTableContainer-root {
    max-height: 400px !important;
  }
`
